module.exports = __webpack_public_path__ + "static/logo-1-words-bc01dceb6e1f3cc8bfb09067e02ef234.png";